import React, { memo } from 'react';
import { ContentStack } from '@/ui/layout';

type Props = {
  children: React.ReactNode;
  className?: string;
};

function AdminPageSectionsInner({ children, className = '' }: Props) {
  return <ContentStack className={className}>{children}</ContentStack>;
}

const AdminPageSections = memo(AdminPageSectionsInner);
AdminPageSections.displayName = 'AdminPageSections';

export default AdminPageSections;
